export default {
      id: "ic_edit_account-usage",
      viewBox: "0 0 28 28",
      url: "/" + "images/icons.3.109.2.svg#ic_edit_account-usage",
      toString: function () {
        return this.url;
      }
    }